  <template>
    <v-card>
        <v-toolbar flat>
            <v-toolbar-title>
                {{ form.note.note_type.desc }} Note
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="orange"
                   small
                   flat
                   rounded
                   outlined
                   icon
                   @click="readOnly = !readOnly"
            >
                <v-icon>edit</v-icon>
            </v-btn>
            <v-btn color="red" @click="remove()" small flat rounded outlined icon><v-icon>delete</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
            <v-layout wrap>
                <v-flex xs12>
                    <v-text-field
                            label="Created"
                            box
                            :value="note.created_at"
                            :readonly="true"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-text-field
                            label="Updated"
                            box
                            :value="note.updated_at"
                            :readonly="true"
                    ></v-text-field>
                </v-flex>
                <v-flex xs6>
                    <v-autcomplete
                            label="Note Type"
                            v-model="form.note.note_type_id"
                            :items="queried.noteTypes"
                            item-text="desc"
                            item-value="id"
                            box
                            :readonly="readOnly"
                    ></v-autcomplete>
                </v-flex>
                <v-flex xs6>
                    <v-text-field
                            label="User"
                            box
                            :value="note.created_by.name"
                            :readonly="true"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-textarea
                            label="Note"
                            box
                            v-model="form.note.note"
                            :readonly="readOnly"
                    ></v-textarea>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions v-if="!readOnly">
            <v-btn flat outlined rounded color="green" @click="save" :loading="controls.loading">Save</v-btn>
            <v-btn flat outlined rounded color="orange" @click="cancel">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import belit from '../Lib/Belit'
    export default {
        name: "DirectoryNoteCard",
        props:{
            note: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                readOnly: true,
                controls:{
                    loading: false,
                },
                form: {
                    note:null
                },
                queried:{
                    noteTypes: [],
                }
            }
        },
        watch:{
            note(){
                this.build();
            }
        },
        created(){
            this.build();
            this.getNoteTypes();
        },
        methods:{
            build(){
                this.form.note = this.note
            },
            async getNoteTypes(){
                let response = belit.get('/notes/types');
                this.queried.noteTypes = response.data;
            },
            async save(){
                this.controls.loading =true;
                try{
                    await belit.post('/notes', this.form.note)
                    this.$store.dispatch("showSuccess", "Saved note.")
                }catch(error){
                    this.$store.dispatch("showError", error)
                }
                this.controls.loading = false;
                this.cancel();
            },
            async remove(){
                try{
                    await belit.post('/contacts/delete', {
                        id: this.form.note.id
                    })
                    this.cancel();
                    this.$store.dispatch("showSuccess", "Deleted address")
                }catch(error){
                    this.$store.dispatch("showError", error)
                }
            },
            cancel(){
                this.readOnly = true;
                this.$emit('reload')
            },
        }
    }
</script>

<style scoped>

</style>
